import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

const StyledContentLoader = styled(ContentLoader)`
  background-color: var(--color-bg-body);
  min-width: 150px;
  width: 150px;
`;

export function HomeTopCategoriesSkeleton() {
  return (
    <StyledContentLoader
      speed={2}
      width={100}
      height={130}
      viewBox="0 0 130 100"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="45" y="0" rx="50" ry="50" width="70" height="70" />
      <rect x="40" y="80" rx="0" ry="0" width="80" height="20" />
    </StyledContentLoader>
  );
}

export const HomeTopCategoriesSkeletons = ({ count = 12 }) =>
  Array.from({ length: count }).map((_, i) => <HomeTopCategoriesSkeleton key={i.toString()} />);
